Selector.View.QuestionView = Backbone.View.extend(
/** @lends Selector.View.QuestionView# */
{	
	/** classname to give the generated element */
	className: "e_selector_item e_selector_question",
	
	/** tagname to give this generated element */
	tagName: "div",
	
	/** template to use for Underscore.js rendering */
    template: _.template($('#selector_question').html()),

    templateWarning: _.template($('#selector_warning').html()),

	events: {
        "click input[type=radio]": 	        "submitAnswer",
        "click .e_selector_button_back": 	"prevQuestion",
        "click .e_selector_button_next": 	"nextQuestion",
        "click .e_selector_button_result":  "showResults"
	},	
	
	/** Render function */
	render: function() {
		
		this.$el.html(this.template(this.model.attributes));//render the HTML

       

		return this; //needed in order to chain rendering
	},

    submitAnswer: function(e) {
        $('.e_selector_button_next').removeAttr('disabled');

        var currentModel = this.model;

        this.getAnswerFromForm();

        this.model.collection.save = true;
        this.model.collection.parseAnswers();

    },

    prevQuestion: function(e) {
        this.model.collection.activatePrevQuestion();
    },

    nextQuestion: function(e) {
        this.model.collection.activateNextQuestion();
    },

    showResults: function(e){
	    //hide show results button (looks stupid)
        //e.currentTarget.style.visibility = "hidden";

	    this.model.collection.showResult = true;
	    this.model.collection.parseAnswers();
        $('html,body').animate({
            scrollTop: $(".e_selector_results").offset().top
        }, 500);
    },

    getAnswerFromForm: function(){

        this.model.set("ERROR", false);

        let $answerInputs = this.$el.find("input:checked"),
            answer = [],
            answerString = "";

        $answerInputs.each(function(i) {
            answer.push($(this).val());
        });

        answerString = answer.join("|");

        if (answerString === "") {
            this.model.set("ERROR", true);
        }
        this.model.set("ANSWER", answerString);

    }


});